import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import ZyGdocDrawingNodeView from './zyGdocDrawing-node-view';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        zyGdocDrawing: {
            insertZyGdocDrawing: (options?: InsertZyGdocDrawingOptions) => ReturnType;
        };
    }
}

export interface InsertZyGdocDrawingOptions {
    alt_text?: string;
    height?: string;
    width?: string;
    pull?: string;
    subject?: string;
    release_id?: string;
    gdoc_file_id?: string;
    gdoc_modified_time?: string;
    image_id?: string;
    aspect_ratio?: string;
}

export const ZyGdocDrawingHeadless = Node.create({
    name: 'zyGdocDrawing',

    group: 'block',

    atom: true,

    selectable: true,

    draggable: true,

    addAttributes() {
        return {
            alt_text: {
                default: '',
                parseHTML: element => element.getAttribute('alt_text'),
                renderHTML: attributes => ({
                    alt_text: attributes.alt_text,
                }),
            },
            height: {
                default: '',
                parseHTML: element => element.getAttribute('height'),
                renderHTML: attributes => ({
                    height: attributes.height,
                }),
            },
            width: {
                default: '',
                parseHTML: element => element.getAttribute('width'),
                renderHTML: attributes => ({
                    width: attributes.width,
                }),
            },
            pull: {
                default: '',
                parseHTML: element => element.getAttribute('pull'),
                renderHTML: attributes => ({
                    pull: attributes.pull,
                }),
            },
            subject: {
                default: '',
                parseHTML: element => element.getAttribute('subject'),
                renderHTML: attributes => ({
                    subject: attributes.subject,
                }),
            },
            release_id: {
                default: '',
                parseHTML: element => element.getAttribute('release_id'),
                renderHTML: attributes => ({
                    release_id: attributes.release_id,
                }),
            },
            gdoc_file_id: {
                default: '',
                parseHTML: element => element.getAttribute('gdoc_file_id'),
                renderHTML: attributes => ({
                    gdoc_file_id: attributes.gdoc_file_id,
                }),
            },
            gdoc_modified_time: {
                default: '',
                parseHTML: element => element.getAttribute('gdoc_modified_time'),
                renderHTML: attributes => ({
                    gdoc_modified_time: attributes.gdoc_modified_time,
                }),
            },
            image_id: {
                default: '',
                parseHTML: element => element.getAttribute('image_id'),
                renderHTML: attributes => ({
                    image_id: attributes.image_id,
                }),
            },
            aspect_ratio: {
                default: '',
                parseHTML: element => element.getAttribute('aspect_ratio'),
                renderHTML: attributes => ({
                    aspect_ratio: attributes.aspect_ratio,
                }),
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'zyGdocDrawing',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'zyGdocDrawing',
            mergeAttributes(HTMLAttributes, {
                'data-type': 'zy-gdoc-drawing',
                class: 'zy-gdoc-drawing-container',
            }),
        ];
    },

    addCommands() {
        return {
            insertZyGdocDrawing:
                (options?: InsertZyGdocDrawingOptions) =>
                ({ commands }) => {
                    return commands.insertContent({
                        type: this.name,
                        attrs: {
                            alt_text: options?.alt_text || '',
                            height: options?.height || '',
                            width: options?.width || '',
                            pull: options?.pull || '',
                            subject: options?.subject || '',
                            release_id: options?.release_id || '',
                            gdoc_file_id: options?.gdoc_file_id || '',
                            gdoc_modified_time: options?.gdoc_modified_time || '',
                            image_id: options?.image_id || '',
                            aspect_ratio: options?.aspect_ratio || '',
                        },
                    });
                },
        };
    },
});
export const ZyGdocDrawing = ZyGdocDrawingHeadless.extend({
    addNodeView() {
        return ReactNodeViewRenderer(ZyGdocDrawingNodeView);
    },
});
